import { IsiControl } from "../Controls/IsiControl";
import { IsiComponentV4 } from "../Component/IsiComponentV4";
import { IIsiComponentManager, IIsiComponentManagerComponentRegisteredEventArgs } from "./IIsiComponentManager";
import { IIsiPageController } from "../Component/IIsiPageController";

// Register the namespace for the control.
//Type.registerNamespace('IsiFW.Components.Manager');

//if (typeof IsiComponentManager == 'undefined') {
//    var IsiComponentManager: IsiFW.Components.Manager.IsiComponentManager;
//}

//if (typeof PageRequestManager == 'undefined') {
//    var PageRequestManager: IsiPageRequestManager;
//}

//export module IsiFW.Components.Manager {

//export var IsiComponentManagerInstance: IsiComponentManager;

//export function getInstance() {
//    return IsiComponentManagerInstance;
//}

export class IsiComponentManager extends IsiControl implements IIsiComponentManager {

    static _instance: IIsiComponentManager;

    components: { [key: string]: any };
    _componentsWithState: { [key: string]: any };
    componentsHandlers: any[];
    _controllerHandlers: ((controller: IIsiPageController) => void)[];
    isFirstLoad: boolean;
    isReady: boolean;
    loaded: boolean;
    imagesFolderUrl: string;
    xmlFolderUrl: string;
    scriptsFolderUrl: string;
    clearComponentState: boolean;

    constructor(element) {
        super(element);
        this.components = [];
        this._componentsWithState = [];
        this.componentsHandlers = new Array();
        this._controllerHandlers = [];
        this.isFirstLoad = true;
        this.isReady = false;
        this.loaded = false;
        this.imagesFolderUrl = "";
        this.xmlFolderUrl = "";
        this.scriptsFolderUrl = "";
        this.clearComponentState = false;
    }

    static getInstance() {
        return IsiComponentManager._instance;
    }

    get webpackPublicPath() {
        return this.get_ScriptsFolderUrl() + "dist/";
    }

    initialize() {
        // initialize the base
        super.initialize();

        //IsiComponentManager = this;
        //(<any>window).PageRequestManager = IsiPageRequestManager.getInstance();
        //window.IsiComponentManager = this;

        IsiComponentManager._instance = this;

        //if (jQuery("#IsiController").exists()) {
        //    require(["_IsiController_Create"], function (fct) {
        //        fct();
        //        uiCore.registerComponentManager(window.IsiComponentManager);
        //    });
        //}



        var me = this;
        //console.log(me.getId() + "Init");
        window.Sys.Application.add_load(
            function (sender, args) {
                if (me.isFirstLoad) {
                    //console.log(me.getId() + "Ready");
                    me.onLoad(sender, args);
                    me.isFirstLoad = false
                }
            });

        if (this.get_ClearComponentState()) {
            this.clearComponentsState();
        }
    }

    dispose() {
        //GBAU - 19/02/2019 - En déchargement de page, on a des erreurs en IE11 
        if (this.get_element()) {
            // release the handlers
            //$clearHandlers(this.get_element());
        }
        // call to the base to do its dispose
        super.dispose();

        this.componentsHandlers = [];

        //iws_ShowUndisposedProperties("IsiFW.Components.Manager.IsiComponentManager", this);
    }

    onLoad(sender, args) {
        this._load(args);
    }

    add_load(handler) {
        this.get_events().addHandler("load", handler);
    }

    remove_load(handler) {
        this.get_events().removeHandler("load", handler);
    }

    _load(args) {
        var handler = this.get_events().getHandler("load");
        if (handler) handler(this, args);
        return;
    }

    add_whenComponentRegistered(handler: (sender: IIsiComponentManager, args: IIsiComponentManagerComponentRegisteredEventArgs) => void) {
        this.get_events().addHandler("whenComponentRegistered", handler);
    }

    remove_whenComponentRegistered(handler: (sender: IIsiComponentManager, args: IIsiComponentManagerComponentRegisteredEventArgs) => void) {
        this.get_events().removeHandler("whenComponentRegistered", handler);
    }

    _whenComponentRegistered(args: IIsiComponentManagerComponentRegisteredEventArgs) {
        var handler = this.get_events().getHandler("whenComponentRegistered");
        if (handler) handler(this, args);
        return;
    }

    registerComponent(cp: IsiComponentV4) {
        var id = cp.getId();
        this.components[id] = cp;
        if (cp.useClientState()) {
            //GBAU - DEV124087 : Gestion d'un état coté client
            this._componentsWithState.push(cp);
        }
        this._whenComponentRegistered({ component: cp });
        if (this.componentsHandlers[id] != undefined) {
            for (var i = 0; i < this.componentsHandlers[id].length; i++) {
                var func = this.componentsHandlers[id][i];
                func(cp);
            }
        }
    }

    IsiGetTranslation(componentInterface: string, getDummiesTranslationHandler) {
        //<summary>renvoi l'objet de traduction associe a l'interface composant passee en parametre</summary>
        var trad;
        if (window["IsiComponentsTranslations"] != undefined) {
            trad = window.IsiComponentsTranslations[componentInterface];
            if (trad) {
                trad.languageCode = window.IsiComponentsTranslations.languageCode;
            }
        }

        // On essaye de récupérer les messages par le biais du handler
        if (!trad) {
            if (getDummiesTranslationHandler) {
                trad = getDummiesTranslationHandler();
            }
        }

        // Affichage d'un message indiquant la marche à suivre pour ajouter les messages aux pages de test
        if (!trad) {

            this.whenComponentReady<any>("popin",
                function (popin) {
                    var msgHTML =
                        "<div style='margin: 25px;'>" +
                        "<p>Merci d'ajouter les messages du composant soit :</p>" +
                        "<ul>" +
                        "<li>En créant une route liant votre composant à un bl avec une méthode BuildTranslations</li>" +
                        "<li>En surchargeant la méthode _getDummiesTranslationOverridable dans votre composant</li>" +
                        "</ul>" +
                        "<i>Cela permet d'avoir les libellés dans les pages de test</i>" +
                        "</div>";

                    popin.showBasicPopin("Ressources du composant absentes", msgHTML);
                })

        }

        return trad;
    }

    whenComponentFound<T extends IsiComponentV4>(id: string, handler: (cp: T) => void) {
        var cp;
        //cp = $find(id);
        cp = this.components[id];

        if (this.componentsHandlers[id] == undefined) {
            this.componentsHandlers[id] = new Array();
        }

        if (cp) {
            handler(cp);
        }

        this.componentsHandlers[id].push(handler);

    }

    whenComponentReady<T extends IsiComponentV4>(id: string, handler: (cp: T) => void) {
        this.whenComponentFound(id,
            function (cp: T) {
                cp.ready(function () {
                    handler(cp);
                });
            });
    }

    /**
     * Permet de s'abonner sur l'événement levé une fois un composant initialisé
     */
    whenComponentInitialized<T extends IsiComponentV4>(id: string, handler: (cp: T) => void) {
        this.whenComponentFound(id, function (cp: T) {
            cp.initialized(function () {
                handler(cp);
            });
        });
    }

    registerController(controller: IIsiPageController) {
        uiCore.controller = controller;
        for (var i = 0; i < this._controllerHandlers.length; i++) {
            var func = this._controllerHandlers[i];
            func(controller);
        }
    }

    whenControllerFound(handler: (controller: IIsiPageController) => void) {
        if (uiCore.controller) {
            handler(uiCore.controller)
        } else {
            this._controllerHandlers.push(handler);
        }
    }
    getComponent<T extends IsiComponentV4>(id: string) {
        return <T>this.components[id];
    }
    /**
      * Retourne le composant à partir d'un objet jQuery
      * @description Dans le cas d'un composant qui crée des éléments à l'exrérieur de son conteneur, il est possible de renseigner l'attribut data-componentid 
                     au même niveau que la classe cp.Cette valeur sera alors utilisé pour retrouver le composant. (03/05/2017 - task 1021395)
      * @param {jQuery} jComponent
      */
    getComponentByJQueryElement<T extends IsiComponentV4>(jComponent) {
        if (jComponent && jComponent.length != 0) {
            let idComponent = jComponent.data('componentid');
            if (!idComponent) {
                idComponent = jComponent.attr('id');
            }
            return this.getComponent<T>(idComponent);
        }
        return null;
    }
    /**
      * Retourne le composant à partir d'un objet jQuery ou HTMLElement enfant
      * @param {(jQuery|HTMLElement)} el
      */
    getParentComponentFromHtmlChildElement(el) {

        let jQueryElement = undefined;

        if (el instanceof HTMLElement) {
            jQueryElement = jQuery(el);
        } else if (el instanceof jQuery) {
            jQueryElement = el;
        }

        if (jQueryElement && jQueryElement.length != 0) {
            const jComponentEl = jQueryElement.closest('.cp');
            return this.getComponentByJQueryElement(jComponentEl);
        }
        return null;
    }
    /**
      * Elle permet de récupérer un composant à partir de l'id d'un élément contenu dans le composant.
      * @param {string} id - L'identifiant utilisé comme base de recherche
      * @returns {any} L'instance du composant recherché
      */
    getParentComponentFromHtmlChildId(id: string) {
        const jComponent = jQuery("#" + CSS.escape(id)).closest(".cp");
        return this.getComponentByJQueryElement(jComponent);
    }
    disposeComponent(cp: IsiComponentV4) {
        this.componentsHandlers[cp.get_id()] = null;
    }

    get_ImagesFolderUrl() {
        return this.imagesFolderUrl;
    }

    set_ImagesFolderUrl(value) {
        this.imagesFolderUrl = value;
    }

    get_XmlFolderUrl() {
        return this.xmlFolderUrl;
    }

    set_XmlFolderUrl(value) {
        this.xmlFolderUrl = value;
    }

    get_ScriptsFolderUrl() {
        return this.scriptsFolderUrl;
    }

    set_ScriptsFolderUrl(value) {
        this.scriptsFolderUrl = value;
    }

    get_ClearComponentState() {
        return this.clearComponentState;
    }

    set_ClearComponentState(value) {
        this.clearComponentState = value;
    }

    getViewstateId() {
        return <string>jQuery("#vsId").val();
    }

    /**
     * Déclenchement de la sauvegarde de l'état des composants
     */
    saveState() {
        jQuery.each(this._componentsWithState, (id, cp: IsiComponentV4) => {
            this.saveComponentState(cp);
        });
    }

    saveComponentState(cp: IsiComponentV4) {
        const cpState = cp.saveState();
        if (cpState) {
            if (cp.isStateResponsibleHimself && cp.isStateResponsibleHimself()) {
                //Si on est en mode client on stocke l'etat dans la session
                if (cp.isStateModeClient() && window.isiSessionStorage) {
                    window.isiSessionStorage.setItem(cp.getStateId(), JSON.stringify(cpState));
                    this.registerSavedState(cp.getStateId());
                    if (cp.isKeepedState()) this.registerKeepedState(cp.getStateId());
                } else {
                    //Si on est en mode serveur on stocke l'etat dans la liste des états clients d'UI
                    if (uiCore.state) {
                        cpState.id = cp.getStateId();
                        uiCore.registerCmpState(cp.getId(), cpState);
                    }
                }
            }
        }
    }

    registerSavedState(id) {
        var savedStates;
        savedStates = window.isiSessionStorage.getItem("IsiComponentManagerComponentsState");
        if (savedStates) {
            savedStates = JSON.parse(savedStates);
        }
        if (!savedStates) {
            savedStates = [];
        }
        if (!savedStates.includes(id)) savedStates.push(id);
        window.isiSessionStorage.setItem("IsiComponentManagerComponentsState", JSON.stringify(savedStates));
    }

    registerKeepedState(id) {
        let keepedStates : Array<string>;
        const jsonKeepedStates = window.isiSessionStorage.getItem("IsiComponentManagerComponentsStateKeeped");
        if (jsonKeepedStates) {
            keepedStates = JSON.parse(jsonKeepedStates);
        }
        else {
            keepedStates = [];
        }
        if (!keepedStates.includes(id)) keepedStates.push(id);
        window.isiSessionStorage.setItem("IsiComponentManagerComponentsStateKeeped", JSON.stringify(keepedStates));
    }

    clearComponentsState() {
        const jsonSavedStates = window.isiSessionStorage.getItem("IsiComponentManagerComponentsState");
        const jsonKeepedStates: string = window.isiSessionStorage.getItem("IsiComponentManagerComponentsStateKeeped");
        let savedStates : Array<string>;
        let keepedStates : Array<string>;
        if (jsonSavedStates) {
            if (jsonKeepedStates) keepedStates = JSON.parse(jsonKeepedStates);
            savedStates = JSON.parse(jsonSavedStates);
            if (savedStates) {
                if (keepedStates) savedStates = savedStates.filter(val => !keepedStates.includes(val));
                jQuery.each(savedStates,
                    function (i, stateId) {
                        window.isiSessionStorage.setItem(stateId, false);
                    });
                window.isiSessionStorage.setItem("IsiComponentManagerComponentsState", false);
            }
        }
    }

    isMotionIsEnabled() {
        return false;
    }

    static IsiCreate = function (id, container, properties, element) {
        // <summary>
        // Cette fonction permet de créer le composant coté client (balise html + objet JS)
        // </summary>
        // <history>
        //		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        // <history>
        var jElement;
        var object;

        jElement = IsiComponentManager.IsiCreateElement(id, container, properties, element);
        if (properties.Index != undefined) {
            properties.Index = undefined;
            delete properties.Index;
        }
        object = IsiComponentManager.IsiCreateObject(id, properties, jElement);

        return object;
    }

    static IsiCreateElement = function (id, container, pProps, element) {
        // <summary>
        // Cette fonction permet de créer la partie html du composant coté client
        // </summary>
        // <history>
        //		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        // <history>

        var jRoot;
        var jValue;

        if (typeof (element) == 'undefined') {
            jRoot = jQuery('<div></div>');
            jRoot.attr("id", id);
        } else {
            jRoot = jQuery(element);
        }

        jRoot.addClass("IsiComponentManager");
        jRoot.attr("tp", "1");

        if (container) {
            jQuery(container).append(jRoot);
        }

        return jRoot;
    }

    static IsiCreateObject = function (id, properties, jElement) {
        // <summary>
        // Cette fonction permet de créer l'objet JS du composant coté client
        // </summary>
        // <history>
        //		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        // <history>
        var object;
        var element;
        element = jElement[0];

        //Instanciation de l'objet IsiTouchPad
        object = new IsiComponentManager(element);
        for (var i in properties) {
            object["set_" + i](properties[i]);
        }
        object.initialize();
        //object = $create((IsiTouchPad) as any, properties, null, null, element);

        return object;
    }
}

//export = IsiComponentManager;
//}
//IsiFW.Components.Manager.IsiComponentManager.registerClass("IsiFW.Components.Manager.IsiComponentManager", Sys.UI.Control);
//if (typeof (Sys) !== 'undefined') Sys.Application.notifyScriptLoaded();
